import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { useConfig } from "../../../context/ConfigContext";

const ServiceCTA = () => {
  const config = useConfig();
  const {
    COMPANY_NAME,
    EMAIL_ADDRESS,
    WHATSAPP_NUMBER_FORM,
    PHONE_NUMBER_FORM,
    GARANTY_YEARS,
    CALL_PHONE_NUMBER,
    WHATSAPP_NUMBER_CHAT,
    PLANTAS_SOLARES,
  } = config;
  const navigate = useNavigate();
  const mensajeWhats = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER_CHAT}&text=${encodeURIComponent(
    `¡Hola! 👋 Me gustaría agendar una consulta gratuita para proyecto solar.
      
    🔋 Necesito:
    - Evaluación técnica de mi propiedad
    - Propuesta personalizada
    - Cálculo de ahorros proyectados
    
    ¿Cuándo podrían realizar la visita?
    
    ¡Gracias!`
  )}`;

  const ctaOptions = [
    {
      title: "Consulta Gratuita",
      description: "Evaluación completa de tu propiedad sin costo",
      icon: "UserCheck",
      action: "Agendar Ahora",
      ref: mensajeWhats,
      type: "external", // URL externa
      highlight: true,
      features: [
        "Visita técnica sin compromiso",
        "Análisis de consumo energético",
        "Propuesta personalizada",
        "Cálculo de ahorros proyectados",
      ],
    },
    {
      title: "Cotización Express",
      description: "Recibe una estimación rápida en línea",
      icon: "Calculator",
      action: "Calcular Ahora",
      ref: `/calculadora`,
      type: "internal",
      highlight: false,
      features: [
        "Resultados en menos de 5 minutos",
        "Estimación de costos",
        "Opciones de financiamiento",
        "Tiempo de recuperación",
      ],
    },
    {
      title: "Llamada Especializada",
      description: "Habla directamente con nuestros expertos",
      icon: "Phone",
      action: "Llamar Ahora",
      ref: `tel:${CALL_PHONE_NUMBER}`,
      type: "phone",
      highlight: false,
      features: [
        "Asesoría técnica inmediata",
        "Resolución de dudas",
        "Orientación sobre incentivos",
        "Programación de visitas",
      ],
    },
  ];

  const contactInfo = [
    {
      type: "Teléfono Principal",
      value: PHONE_NUMBER_FORM,
      icon: "Phone",
    },
    {
      type: "WhatsApp",
      value: `${WHATSAPP_NUMBER_FORM}`,
      icon: "MessageCircle",
    },
    {
      type: "Email",
      value: `${EMAIL_ADDRESS}`,
      icon: "Mail",
    },
  ];

  const handleCTAClick = (option) => {
    switch (option.type) {
      case "external":
        window.open(option.ref, "_blank"); // Para URLs externas, abre en nueva ventana
        break;
      case "internal":
        navigate(option.ref);
        break;
      case "phone":
        window.location.href = option.ref; // Para llamadas, usar tel:
        break;
      default:
        console.log("Tipo de CTA no reconocido");
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-primary/10 via-white to-secondary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            Comienza Tu Proyecto Solar Hoy
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Da el primer paso hacia la independencia energética. Nuestros
            expertos están listos para ayudarte a diseñar la solución solar
            perfecta.
          </p>
        </div>

        {/* CTA Options */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {ctaOptions?.map((option, index) => (
            <div
              key={index}
              className={`rounded-2xl p-8 solar-shadow-card solar-hover-lift ${option?.highlight
                ? "bg-gradient-to-br from-orange-600 to-orange-700 text-white shadow-xl"
                : "bg-white"
                }`}
            >
              <div className="text-center mb-6">
                <div
                  className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${option?.highlight ? "bg-white/30" : "bg-primary/10"
                    }`}
                >
                  <Icon
                    name={option?.icon}
                    size={32}
                    className={
                      option?.highlight ? "text-white" : "text-primary"
                    }
                  />
                </div>
                <h3
                  className={`text-xl font-bold mb-2 ${option?.highlight ? "text-white" : "text-text-primary"
                    }`}
                >
                  {option?.title}
                </h3>
                <p
                  className={`text-sm ${option?.highlight ? "text-white" : "text-text-secondary"
                    }`}
                >
                  {option?.description}
                </p>
              </div>

              <ul className="space-y-3 mb-8">
                {option?.features?.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <Icon
                      name="Check"
                      size={16}
                      className={`flex-shrink-0 ${option?.highlight ? "text-white" : "text-success"
                        }`}
                    />
                    <span
                      className={`text-sm ${option?.highlight
                        ? "text-white"
                        : "text-text-secondary"
                        }`}
                    >
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <Button
                variant={option?.highlight ? "secondary" : "default"}
                fullWidth
                size="lg"
                iconName="ArrowRight"
                iconPosition="right"
                className={
                  option?.highlight
                    ? "bg-white text-primary hover:bg-white/90"
                    : "bg-cta-orange hover:bg-cta-orange/90"
                }
                onClick={() => handleCTAClick(option)}
              >
                {option?.action}
              </Button>
            </div>
          ))}
        </div>

        {/* Contact Information */}
        <div className="bg-white rounded-2xl p-8 solar-shadow-card">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-text-primary mb-2">
              Múltiples Formas de Contacto
            </h3>
            <p className="text-text-secondary">
              Elige la opción que más te convenga para comenzar tu proyecto
              solar
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 mb-8">
            {contactInfo?.map((contact, index) => (
              <div
                key={index}
                className="text-center p-4 bg-muted/30 rounded-xl w-64"
              >
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Icon
                    name={contact?.icon}
                    size={24}
                    className="text-primary"
                  />
                </div>
                <h4 className="font-bold text-text-primary mb-1">
                  {contact?.type}
                </h4>
                <p className="text-sm text-primary font-medium mb-2">
                  {contact?.value}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center mt-12">
          <div className="max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-text-primary mb-4">
              ¿Listo para Generar Tu Propia Energía?
            </h3>
            <p className="text-text-secondary mb-8">
              Únete a más de {PLANTAS_SOLARES} plantas solares que ya
              disfrutan de energía limpia y ahorros reales con {COMPANY_NAME}.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/calculadora">
                <Button
                  variant="default"
                  size="xl"
                  iconName="Calculator"
                  iconPosition="left"
                  className="bg-cta-orange hover:bg-cta-orange/90"
                >
                  Calcular Mis Ahorros
                </Button>
              </Link>
              <Button
                variant="outline"
                size="xl"
                iconName="Calendar"
                iconPosition="left"
                onClick={() => window.open(mensajeWhats)}
              >
                Agendar Consulta Gratuita
              </Button>
            </div>

            <div className="mt-8 flex items-center justify-center gap-8 text-sm text-text-secondary">
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={16} />
                <span>Garantía hasta {GARANTY_YEARS} años</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Award" size={16} />
                <span>Certificación internacional</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Users" size={16} />
                <span>{PLANTAS_SOLARES}+ plantas solares</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCTA;
